import '../../styles/SkillJudge.css';

import React, { useState } from 'react';

import { Typography } from './index';

interface SkillJudgeProps {
  title: string;
  value?: number;
  onChange?: (value: number) => void;
}

export default function SkillJudge({ 
  title, 
  value = 0, 
  onChange 
}: SkillJudgeProps) {
  const [showTooltip, setShowTooltip] = useState(false);
  
  const handleRatingChange = (rating: number) => {
    if (onChange) {
      onChange(rating);
    }
  };
  
  return (
    <div className="skill-judge">
      <div className="skill-header">
        <Typography variant="h3">{title}</Typography>
        <div 
          className="tooltip-trigger"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <span className="question-mark">?</span>
          {showTooltip && (
            <div className="tooltip">
              <div className="tooltip-content">
                <Typography variant="body" className="tooltip-title">Judging Scale</Typography>
                <div className="tooltip-scale">
                  <div className="scale-item">
                    <span className="scale-number">1</span>
                    <span className="scale-label">-  Poor</span>
                  </div>
                  <div className="scale-item">
                    <span className="scale-number">2</span>
                    <span className="scale-label">-  Needs Work</span>
                  </div>
                  <div className="scale-item">
                    <span className="scale-number">3</span>
                    <span className="scale-label">-  Average</span>
                  </div>
                  <div className="scale-item">
                    <span className="scale-number">4</span>
                    <span className="scale-label">-  Above Average</span>
                  </div>
                  <div className="scale-item">
                    <span className="scale-number">5</span>
                    <span className="scale-label">-  Excellent</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      
      <div className="rating-bar">
        {[0, 1, 2, 3, 4, 5].map((rating) => (
          <div 
            key={rating}
            className={`rating-segment ${value === rating ? 'selected' : ''} ${rating === 0 ? 'zero' : ''}`}
            onClick={() => handleRatingChange(rating)}
          >
            {rating}
          </div>
        ))}
      </div>
    </div>
  );
} 